import styled from 'styled-components';

export const MultilineText = styled.div`
  display: inline-block;
  white-space: pre-line;
`;
